var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 9.01l-1.872-1.884.425-2.622-2.621-.423-1.198-2.371-2.369 1.197-2.359-1.194-1.215 2.361-2.616.405.405 2.624-1.88 1.886 1.855 1.87-.423 2.603 2.622.425 1.198 2.37 2.37-1.197 2.361 1.214 1.214-2.362 2.625-.406-.406-2.624z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.87 8.645a.75.75 0 01.984-.067l.076.067 1.211 1.212 3.146-3.146a.75.75 0 01.984-.067l.077.067a.75.75 0 01.067.984l-.067.077-3.676 3.676a.75.75 0 01-.984.067l-.077-.067L5.87 9.706a.75.75 0 010-1.06z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedSolid);
export default __webpack_public_path__ + "static/media/VerifiedSolid.69fb1a27.svg";
export { ForwardRef as ReactComponent };